import { Checkbox } from 'element-ui';
import { Switch as LSwitch } from '@/components/index';
import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';
import TableData from '@/components/admin/races/table/table.vue';
import FilterBar from '@/components/admin/races/filter-bar/filter-bar.vue';
import RaceLayout from '@/components/user/dashboard/pages/races/view-race/layout/layout.vue';
import { Pagination as LPagination } from '@/components/index';

export default {
    name: 'RaceAdminLayout',
    components: {
        'table-data': TableData,
        'filter-bar': FilterBar,
        'race-layout': RaceLayout,
        LPagination, [Checkbox.name]: Checkbox
    },
    watch: {
        filter: {
            immediate: true,
            handler(newVal, oldVal) {
                if (JSON.stringify(newVal) == JSON.stringify(oldVal)) {
                    return;
                }
                if (!oldVal) {
                    this.init();
                }
                else {
                    this.load();
                }
            }
        },
        page: {
            immediate: true,
            handler(newVal) {
                if (newVal != this.filter.options.page) {
                    this.filter.options.page = newVal;
                    this.load();
                }
            }
        },
    },
    data() {
        return {
            isProcessing: false,
            currentRaceId: null,
            tableData: [],
            filter: {
                name: null,
                location: null,
                year: null,
                typeByEvent: null,
                typeBySport: null,
                typeByAgeGroup: null,
                distance: null,
                status: null,
                isUsedTiForEntry: null,
                options: { skip: 0, take: 5, perPage: 5, page: 1 }
            },
            typesBySport: [],
            typesByEvent: [],
            distances: [],
            statuses: [],
            years: [],
            total: 0,
            page: 1,

            isExport: false,
            filterRaceId: null,
            exportOptions: [],
            isSwitherExportOne: false
        }
    },
    computed: {
        isNeedSupportData() {
            return !this.typesBySport.length ||
                !this.typesByEvent.length ||
                !this.distances.length ||
                !this.statuses.length ||
                !this.years.length;
        },
        skip() {
            return (this.filter.options.page - 1) * this.filter.options.perPage;
        },
        take() {
            return this.filter.options.perPage;
        },
        from() {
            return this.skip + 1;
        },
        to() {
            return this.skip + this.take;
        },
        raceId() {
            if (this.$route && this.$route && this.$route.query && this.$route.query.raceId) {
                return this.$route.query.raceId;
            }
            return 0;
        }
    },
    methods: {
        init() {
            this.load();
        },
        getFilter()
        {
            let filter = { ...this.filter };
            filter.options.skip = this.skip;
            filter.options.take = this.take;
            filter.isNeedSupportData = this.isNeedSupportData;
            return filter;
        },
        load() {
            const self = this;
            if (self.isProcessing) {
                return;
            }

            self.isProcessing = true;
            request.getRacesList(self.getFilter())
                .then(res => {
                    self.isProcessing = false;
                    if (res && res.body && res.body.isSuccess) {
                        self.tableData = res.body.outputData.data;
                        self.total = res.body.outputData.total;
                        if (self.isNeedSupportData) {
                            self.distances = res.body.outputData.supportData.distances;
                            self.distances.unshift({ id: null, label: 'None', value: null });

                            self.typesByEvent = res.body.outputData.supportData.typesByEvent;
                            self.typesByEvent.unshift({ id: null, label: 'None', value: null });

                            self.typesBySport = res.body.outputData.supportData.typesBySport;
                            self.typesBySport.unshift({ id: null, label: 'None', value: null });

                            self.years = res.body.outputData.supportData.years;
                            self.years.unshift({ id: null, label: 'None', value: null });

                            self.statuses = res.body.outputData.supportData.statuses;
                            self.statuses.unshift({ id: null, label: 'None', value: null });

                            const supportData = res.body.outputData.supportData.exportOptions;
                            if (supportData && supportData.length) {
                                self.exportOptions = supportData;

                                for (var i = 0; i < 14; i++) {
                                    self.exportOptions[i].readOnly = true;
                                    self.exportOptions[i].isOnExport = true;
                                }
                            }
                        }
                    }
                    else {
                        self.$showError(res && res.body && res.body.message ? res.body.message : null, 5000);
                    }
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError(5000);
                    });
        },
        getReportAll() {
            var self = this;
            self.isProcessing = true;

            var filter = self.getFilter();
            filter.isExportOneRace = false;
            filter.isExport = true;
            filter.exportColumnsVisibility = [];

            self.exportOptions.forEach(item => {
                if (item.isOnExport) {
                    filter.exportColumnsVisibility.push(item.label);
                }
            });

            filter.exportColumnsVisibilityInput = filter.exportColumnsVisibility.join("||");

            request.getRaceDetailsByOptions(filter)
                .then(resp => {
                    self.isProcessing = false;
                    var allData = resp.body;
                    if (!allData || allData.errorMessage) {

                        if (!allData.currentUserId) {
                            self.$showError("You are not authorized!");
                            setTimeout(() => { self.$router.push('/') }, 2000);
                        }
                    }

                    self.exportToExcel(allData.outputData, filter.isExportOneRace);
                    self.errorMessage = allData.message;
                }, () => {
                    self.isProcessing = false;
                    self.errorMessage = "Server has not responded. Probably, connection is lost. Please try again later."
                    return [];
                });
        },
        exportList() {
            const self = this;
            self.isProcessing = true;
            request.getExportRacesList(self.getFilter())
                .then(res => {
                    self.isProcessing = false;
                    if (res && res.body && res.body.isSuccess) {
                        if (res.body.outputData.isSuccess) {
                            self.saveExport(res.body.outputData.data);
                        }
                        else {
                            self.$showError(res && res.body && res.body.outputData && res.body.outputData.errorMessage ? res.body.outputData.errorMessage : null, 5000);
                        }
                    }
                    else {
                        self.$showError(res && res.body && res.body.message ? res.body.message : null, 5000);
                    }
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError(5000);
                    });
        },
        saveExport(data) {
            var ws = XLSX.utils.json_to_sheet(this.createRacesViewSheet(data));
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Races");
            XLSX.writeFile(wb, "Races.xlsx");
        },
        createRacesViewSheet(data) {
            return data.map(item => {
                var newItem = {
                    "Name": item.raceName,
                    "Distance": item.distance,
                    "Event Type": item.typeBySport,
                    "Status": item.raceStatusLabel,
                    "Start Time": item.startTimeString,
                    "Location": item.locationString,
                    "Type": item.typeByEvent,
                    "Age Group": item.ageGroupLabel,
                    "Used TI Entry": item.isUsedTiForEntry ? "Yes" : "No"
                }
                return newItem;
            })
        },
        switchReport(isSwitherExportOne) {
            this.isSwitherExportOne = isSwitherExportOne;
            this.isExport = !this.isExport;
        },
        getExport() {
            if (this.isSwitherExportOne) { this.getReportOne(); }
            else if (!this.isSwitherExportOne) { this.getReportAll(); }
        },
        revertToRows(objectItem) {
            var arr = [];
            var keys = Object.keys(objectItem);
            const column1 = keys[0];
            const column2 = objectItem[keys[0]];

            for (var key in keys) {
                if (key > 0) {
                    var obj = {};
                    obj[column1] = keys[key];
                    obj['z_'+column2] = objectItem[keys[key]];
                    
                    arr.push(obj);
                }
            }
            return arr;
        },
        exportToExcel(data, isExportOneRace) {
            if (data && data.length) {
                const exportData = isExportOneRace ? this.revertToRows(data[0]) : data;
                var ws = XLSX.utils.json_to_sheet(exportData);
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Race");
                XLSX.writeFile(wb, "Race.xlsx");
            }
            else {
                this.$showError("Records are not loaded");
            }
        },
        getReportOne() {
            var self = this;
            self.isProcessing = true;

            var filter = self.getFilter();
            filter.isExportOneRace = true;
            filter.isExport = true;
            filter.exportColumnsVisibility = [];
            filter.raceId = this.filterRaceId;

            self.exportOptions.forEach(item => {
                if (item.isOnExport) {
                    filter.exportColumnsVisibility.push(item.label);
                }
            });

            filter.exportColumnsVisibilityInput = filter.exportColumnsVisibility.join("||");

            request.getRaceDetailsByOptions(filter)
                .then(resp => {
                self.isProcessing = false;
                var allData = resp.body;
                if (!allData || allData.errorMessage) {

                    if (!allData.currentUserId) {
                        self.$showError("You are not authorized!");
                        setTimeout(() => { self.$router.push('/') }, 2000);
                    }
                }

                self.exportToExcel(allData.outputData, filter.isExportOneRace);
                self.errorMessage = allData.message;
            }, () => {
                    self.isProcessing = false;
                self.errorMessage = "Server has not responded. Probably, connection is lost. Please try again later."
                return [];
            });
        },
    },
    mounted() {
        if (this.raceId) {
            this.currentRaceId = this.raceId;
            //this.$router.push('/admin/races');
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/races/layout/layout.js